export default "__VITE_ASSET__yKqjkyIh__"